import { VisitorInfo } from './visitor-info';

function getUser(): User {
    if ( !window.user ) {
        window.user = new User( window.userStub || {} );
    }
    return window.user;
}

class User {
    isVerified = false;
    phoneOne: string;
    phoneTwo: string;

    _visitorInfo?: VisitorInfo;

    constructor( userStub: UserStub ) {
        this.isVerified = userStub.isVerified || false;
        this.phoneOne = userStub.phoneOne || '';
        this.phoneTwo = userStub.phoneTwo || '';
    }

    visitorInfo(): VisitorInfo {
        return window.vinfo;
    }
}

type Subscriber = {
	ID: number;
	Email: string;
	Language: string;
	Token: string;
	Newsletter: boolean;
	PropertyAlerts: boolean;
	Partners: boolean;
	NotificationFrequency: string;
	NoEmailsUntil: string;
}

export {
    User,
    Subscriber,
    getUser,
};
